/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

'use strict';

angular.module('bulbApp.organizationModule')
.component('dashboardAccountHover', {
  templateUrl: 'ajs/organization/organization-account-hover.html',
  bindings: {
    name: '@',
    orgId: '@',
    canOffboard: '<'
  },
  controller: ['BulbAuthService', 'BulbBusyService', 'BulbErrorService', 'BulbModalService', 'Restangular',
  function(BulbAuthService, BulbBusyService, BulbErrorService, BulbModalService, Restangular) {
    // This function signs the current org admin into the account.
    this.signInAs = function() {
      BulbAuthService.adminSignInAs(this.name);
    };

    this.offboardUser = function() {
      var that = this;

      var offboardUserModalOptions = {
        titleCode : 'offboard_user_modal_title',
        bodyCode: 'offboard_user_modal_body',
        cancelButtonCode: 'account_settings_cancel',
        okButtonCode: 'offboard_user_modal_button',
        fontAwesomeCode : 'fas fa-user-slash',
        // The styles in the bulb-onboarding-end-tour duplicate the styles needed here.
        windowClass : 'updated-modal-design bulb-onboarding-end-tour'
      };

      BulbModalService.show(offboardUserModalOptions).then(function() {
        BulbBusyService.showBusyDuring(
          Restangular.one('accounts', that.name).customDELETE('offboard/' + that.orgId).then(function() {
            document.getElementById(that.name).classList.add('hide');
          }).catch(function (err) {
            BulbErrorService.showError(null, err);
          })
        );
      });
    };
  }]
});
